// extracted by mini-css-extract-plugin
export default {"wrap":"LeadAssigneeSelect_wrap__AP5Op","select":"LeadAssigneeSelect_select__9azVq","hint":"LeadAssigneeSelect_hint__fCJA7","error":"LeadAssigneeSelect_error__vdKg1"};